// extracted by mini-css-extract-plugin
module.exports = {"itemBonus":"ItemBonus_itemBonus__2W-NX","isIncreasing":"ItemBonus_isIncreasing__1iq9u","isDecreasing":"ItemBonus_isDecreasing__3WOBl","isSpecial":"ItemBonus_isSpecial__15oMu"};